angular.module('gym.gocardless').controller('GoCardlessImportCtrl', ["$rootScope", "$scope", "$state", "$modal", "$timeout", "$window", "flash", "ngTableParams", "GoCardless", "loadingAnimation", "EmploymentService", "ToggleTableFiltersService", "ActionCable", function($rootScope, $scope, $state, $modal, $timeout, $window, flash, ngTableParams, GoCardless, loadingAnimation, EmploymentService, ToggleTableFiltersService, ActionCable) {
  var UnallocatedMandates, getMeta, gym, unsubscribe;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.gym = gym = $rootScope.gym;
  $scope.queryParams = {};
  UnallocatedMandates = GoCardless.all('unallocated_mandates');
  if (!$scope.permissions.perform_bulk_mandate_imports) {
    $state.go('gym.dashboard');
  }
  $scope.pageParams = {
    filtersOpen: ToggleTableFiltersService.isOpen('GoCardlessImport')
  };
  unsubscribe = ActionCable.create({
    channel: "GocardlessMandateSyncChannel",
    gym_id: $scope.gym.id
  }, function(message) {
    return $timeout(function() {
      var ref;
      if ((ref = message.message) === 'sync_complete' || ref === 'sync_failed') {
        getMeta();
        if (message.message === 'sync_complete') {
          flash.success = "Mandate sync completed successfully";
        }
        if (message.message === 'sync_failed') {
          flash.error = "Mandate sync failed";
        }
        return $scope.tableParams.reload();
      }
    });
  });
  $scope.$on('$destroy', function() {
    return unsubscribe();
  });
  getMeta = function() {
    return UnallocatedMandates.customGET('meta').then(function(response) {
      $scope.syncInProgress = response.mandate_sync_in_progress;
      return $scope.lastSyncedAt = response.mandates_list_last_synced_at;
    });
  };
  getMeta();
  $scope.toggleFilters = function() {
    $scope.pageParams.filtersOpen = !$scope.pageParams.filtersOpen;
    return ToggleTableFiltersService.toggle($scope.pageParams.filtersOpen, 'GoCardlessImport');
  };
  $scope.toggleFiltersModal = function() {
    var filtersModal;
    filtersModal = $modal.open({
      template: require('templates/gyms/gocardless/import/filters_modal.html.slim'),
      resolve: {
        options: function() {
          return {};
        },
        filters: function() {
          return $scope.queryParams;
        }
      },
      controller: 'FiltersModalCtrl'
    });
    return filtersModal.result.then(function(result) {
      $scope.queryParams = result;
      return $scope.tableParams.reload();
    });
  };
  $scope.refresh = function() {
    var message;
    message = `This will sync all of your unallocated Mandate information from GoCardless to Clubworx. This process may be useful if you have recently added Mandates to your GoCardless account, but they are not showing in Clubworx yet.\n
If you have already performed a Mandate refresh and you believe it has not synced all of your Mandates, please contact Clubworx support directly.`;
    if ($window.confirm(message)) {
      UnallocatedMandates.doPOST({}, 'refresh');
      $scope.syncInProgress = true;
      return $timeout(function() {
        return getMeta();
      }, 5000);
    }
  };
  $scope.onSearch = _.debounce((function(request) {
    return $scope.tableParams.reload();
  }), 500);
  $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      loadingAnimation.show();
      params = angular.extend($params.url(), $scope.queryParams);
      return UnallocatedMandates.getList(params).then(function(data) {
        loadingAnimation.hide();
        if (data.meta) {
          $params.total(data.meta.total);
          return $defer.resolve(data);
        } else {
          $params.total(data.total);
          return $defer.resolve(data.collection);
        }
      }, function(response) {
        loadingAnimation.hide();
        return flash.error = response.data.error || "There was an error processing the request.";
      });
    }
  });
  return $scope.showLinkModal = function(mandate) {
    var roomModal;
    roomModal = $modal.open({
      template: require('templates/gyms/gocardless/import/link_modal.html.slim'),
      resolve: {
        mandate: function() {
          return mandate;
        }
      },
      controller: ["$scope", "$window", "$modalInstance", "$http", "flash", "mandate", function($scope, $window, $modalInstance, $http, flash, mandate) {
        $scope.onSelect = function(contact) {
          var message, url;
          message = `This will link mandate ${mandate.bank_account_reference} (${mandate.mandate_reference}) to ${contact.name} (${contact.email}). Are you sure?`;
          if ($window.confirm(message)) {
            url = `/gyms/${gym.id}/gocardless/unallocated_mandates/${mandate.id}`;
            return $http.put(url, {
              contact_id: contact.id
            }).then(function() {
              return $modalInstance.close();
            }, function() {
              flash.error = "Request could not be completed. Please try again";
              return $modalInstance.close();
            });
          }
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
    return roomModal.result.then(function() {
      return $scope.tableParams.reload();
    });
  };
}]);
